export function nameToRoute(name: string): string {
  return name.toLowerCase().replace(/\s+/g, '-');
}
